import React from "react";
import { registerRootComponent } from "expo";
import App from "./src/App"; // <- comment for storybook
// import storybook from "./storybook"; // <- uncomment for storybook

registerRootComponent(() => <App />); // <- comment for storybook
// registerRootComponent(storybook); // <- uncomment for storybook
